module.exports = __webpack_public_path__ + "static/media/item_39_3.bb151e55.png";